import { appUrls } from "@/constants";

// Re-export getModelPrice for use by ModelCard
export { getModelPrice } from "./api-pricing-data";

// Import model cover images
import FlashCover from "./covers/Flash.png";
import MultilingualCover from "./covers/Multilingual.png";
import ScribeCover from "./covers/Scribe.png";
import ScribeRealtimeCover from "./covers/Scribe realtime.png";
import MusicCover from "./covers/Music.png";
import VoiceIsolatorCover from "./covers/Voice Isolator.png";
import VoiceChangerCover from "./covers/Voice changer.png";
import SFXCover from "./covers/SFX.png";
import DubbingCover from "./covers/Dubbing.png";

// Image map for model card backgrounds
const MODEL_COVER_IMAGES = {
  flash_turbo: FlashCover,
  multilingual_v2_v3: MultilingualCover,
  scribe_v1_v2: ScribeCover,
  scribe_v2_realtime: ScribeRealtimeCover,
  speech_engine: FlashCover,
  music: MusicCover,
  voice_isolator: VoiceIsolatorCover,
  voice_changer: VoiceChangerCover,
  sound_effects: SFXCover,
  dubbing_v1: DubbingCover,
} as const;

export const MODELS_PRICING_DATA = [
  {
    id: "flash_turbo",
    nameLabelKey: "flash_turbo_name",
    categoryLabelKey: "category_text_to_speech",
    priceUnitLabelKey: "price_unit_per_1k_characters",
    featureLabelKeys: ["flash_turbo_feature_1", "flash_turbo_feature_2", "flash_turbo_feature_3"],
    coverImage: MODEL_COVER_IMAGES.flash_turbo,
    ctaLink: appUrls.textToSpeech,
  },
  {
    id: "multilingual_v2_v3",
    nameLabelKey: "multilingual_v2_v3_name",
    categoryLabelKey: "category_text_to_speech",
    priceUnitLabelKey: "price_unit_per_1k_characters",
    featureLabelKeys: [
      "multilingual_feature_1",
      "multilingual_feature_2",
      "multilingual_feature_3",
      "multilingual_feature_4",
    ],
    coverImage: MODEL_COVER_IMAGES.multilingual_v2_v3,
    ctaLink: appUrls.textToSpeech,
  },
  {
    id: "scribe_v1_v2",
    nameLabelKey: "scribe_v1_v2_name",
    categoryLabelKey: "category_speech_to_text",
    priceUnitLabelKey: "price_unit_per_hour",
    featureLabelKeys: ["scribe_v1_feature_1", "scribe_v1_feature_2", "scribe_v1_feature_3", "scribe_v1_feature_4"],
    coverImage: MODEL_COVER_IMAGES.scribe_v1_v2,
    ctaLink: appUrls.speechToText,
  },
  {
    id: "scribe_v2_realtime",
    nameLabelKey: "scribe_v2_realtime_name",
    categoryLabelKey: "category_speech_to_text",
    priceUnitLabelKey: "price_unit_per_hour",
    featureLabelKeys: ["scribe_v2_feature_1", "scribe_v2_feature_2", "scribe_v2_feature_3", "scribe_v2_feature_4"],
    coverImage: MODEL_COVER_IMAGES.scribe_v2_realtime,
    ctaLink: appUrls.speechToText,
  },
  {
    id: "speech_engine",
    nameLabelKey: "speech_engine_name",
    categoryLabelKey: "category_agents",
    priceUnitLabelKey: "price_unit_per_minute",
    featureLabelKeys: [
      "speech_engine_feature_1",
      "speech_engine_feature_2",
      "speech_engine_feature_3",
      "speech_engine_feature_4",
    ],
    coverImage: MODEL_COVER_IMAGES.speech_engine,
    ctaLink: appUrls.speechEngine,
  },
  {
    id: "music",
    nameLabelKey: "music_name",
    categoryLabelKey: "category_music_generation",
    priceUnitLabelKey: "price_unit_per_minute",
    featureLabelKeys: ["music_feature_1", "music_feature_2", "music_feature_3"],
    coverImage: MODEL_COVER_IMAGES.music,
    ctaLink: appUrls.music,
  },
  {
    id: "voice_isolator",
    nameLabelKey: "voice_isolator_name",
    categoryLabelKey: "category_audio_processing",
    priceUnitLabelKey: "price_unit_per_minute",
    featureLabelKeys: ["voice_isolator_feature_1", "voice_isolator_feature_2", "voice_isolator_feature_3"],
    coverImage: MODEL_COVER_IMAGES.voice_isolator,
    ctaLink: appUrls.voiceIsolator,
  },
  {
    id: "voice_changer",
    nameLabelKey: "voice_changer_name",
    categoryLabelKey: "category_audio_processing",
    priceUnitLabelKey: "price_unit_per_minute",
    featureLabelKeys: ["voice_changer_feature_1", "voice_changer_feature_2", "voice_changer_feature_3"],
    coverImage: MODEL_COVER_IMAGES.voice_changer,
    ctaLink: appUrls.voiceChanger,
  },
  {
    id: "sound_effects",
    nameLabelKey: "sound_effects_name",
    categoryLabelKey: "category_audio_generation",
    priceUnitLabelKey: "price_unit_per_generation",
    featureLabelKeys: ["sound_effects_feature_1", "sound_effects_feature_2", "sound_effects_feature_3"],
    coverImage: MODEL_COVER_IMAGES.sound_effects,
    ctaLink: appUrls.soundEffects,
  },
  {
    id: "dubbing_v1",
    nameLabelKey: "dubbing_v1_name",
    categoryLabelKey: "category_dubbing",
    priceUnitLabelKey: "price_unit_per_minute",
    featureLabelKeys: ["dubbing_v1_feature_1", "dubbing_v1_feature_2", "dubbing_v1_feature_3"],
    coverImage: MODEL_COVER_IMAGES.dubbing_v1,
    ctaLink: appUrls.dubbing,
  },
] as const;

// Derive the type from the actual data
export type ModelPricingData = (typeof MODELS_PRICING_DATA)[number];
